export default __webpack_public_path__ + "static/media/wonderland-skit.7a8201a1.jpeg";